import React from "react";
import "./SubscriptionDetailsTab.scss";
import SubscriptionDetailsIcon1 from "assets/images/SubscriptionDetailsIcon1.png";
import SubscriptionDetailsIcon2 from "assets/images/SubscriptionDetailsIcon2.png";
import Button from "common/components/Button";
import Input from "common/components/Input/Input";
import { useTypedSelector } from "store";
import DateIcon from "assets/images/date-icon.svg";

interface Props {
  onCancelSubscription: () => void;
}

const SubscriptionDetailsTabMobile = ({ onCancelSubscription }: Props) => {
  const { client } = useTypedSelector((store) => store.user);
  console.log("client?.subscription?.nextPayment", client.subscription);
  return (
    <div className="personalInformationTab-form-main-mobile SubscriptionDetailsTab-form-main-mobile">
      <div className="personalInformationTab-label-block" style={{ paddingTop: 16 }}>
        <div className="PersonalInfo-icon-otr">
          <img className="PersonalInfo-icon" src={SubscriptionDetailsIcon1} alt="icon" />
        </div>
        <h3>פרטי המנוי</h3>
      </div>
      <div
        className="personalInformationTab-form"
        style={{ marginTop: 10, gap: 10, display: "flex", flexDirection: "column" }}>
        <div className="PersonalInfo-Input-otr">
          <Input
            value={client?.subscription?.expiration}
            label="החיוב הבא בתאריך"
            placeholder="לא פעיל"
            disabled
          />
          <div className="PersonalInfo-Input-otr">
            <Input label="מסלול" placeholder="מסלול" value={client?.subscription?.type} />
          </div>
          <div className="PersonalInfo-Input-otr">
            <Input label="חידוש" placeholder="חידוש" value={client?.subscription?.renew} />
          </div>
        </div>
      </div>
      <div className="personalInformationTab-label-block" style={{ paddingTop: 16 }}>
        <div className="PersonalInfo-icon-otr">
          <img className="PersonalInfo-icon" src={SubscriptionDetailsIcon2} alt="icon" />
        </div>
        <h3>מסלול מתחדש</h3>
      </div>
      <div
        className="personalInformationTab-form"
        style={{ marginTop: 10, gap: 10, display: "flex", flexDirection: "column" }}>
        <div className="PersonalInfo-Input-otr" style={{ position: "relative" }}>
          <Input
            value={client?.subscription?.nextPayment}
            label="החיוב הבא בתאריך"
            placeholder="לא פעיל"
            disabled
          />
          <div style={{ position: "absolute", left: 10, top: 10 }}>
            <img
              className="date-icon"
              src={DateIcon}
              alt="icon"
              style={{ width: 26, height: 26 }}
            />
          </div>
        </div>
        {!!client?.subscription?.nextPayment && (
          <Button
            text=" ביטול חידוש אוטומטי"
            typeBtn="red"
            style={{ marginTop: 30 }}
            onClick={onCancelSubscription}
          />
        )}
      </div>
    </div>
  );
};

export default SubscriptionDetailsTabMobile;
